var map = {
	"./Facebook.svg": 291,
	"./Insta.svg": 290,
	"./Linkedin.svg": 294,
	"./Twitter.svg": 292,
	"./Youtube.svg": 293,
	"./bncimagenes.png": 498,
	"./bonificaciones.png": 499,
	"./calendar.svg": 298,
	"./clientes.svg": 500,
	"./download.svg": 501,
	"./editar.svg": 299,
	"./editar_black.svg": 300,
	"./excel-logo.png": 301,
	"./manualmarca.png": 502,
	"./menu.svg": 297,
	"./precios.png": 503,
	"./presupuesto.svg": 504,
	"./vendedores.svg": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 497;